import { useGetters } from 'vuex-composition-helpers'
import { computed, Ref } from 'vue'
import type { MultiselectOption } from '@ironsight/types'
import Task from '@/models/task.js'

export function useActivityFilter(): { options: Ref<MultiselectOption[]> } {
  const { getAllItems: getActivities } = useGetters('tasks', ['getAllItems'])

  const options = computed<MultiselectOption[]>(() => {
    const activities = Object.values(getActivities.value || {}) as Task[]

    const grouped = activities
      .filter((a) => a.isActive)
      .reduce(
        (acc, activity) => {
          const key = activity.name.toLowerCase()
          acc[key] = acc[key] || []
          acc[key].push(activity)
          return acc
        },
        {} as Record<string, Task[]>,
      )

    return (Object.values(grouped) as Task[][])
      .map((group) => ({
        label: group[0].name,
        value: group.map((a) => a.id).join(','),
      }))
      .sort((a, b) => a.label.localeCompare(b.label))
  })

  return { options }
}
